import { apiService } from "../api.service";

export const verifyUser = async (token: string) => {
  return apiService.apiRequest<any>("post", `auth/verify-account`, { token });
};
